import { Component } from '@angular/core';
import { PieChartComponent } from '../../../charts/pie-chart.component'; 
import { TableViewComponent } from "../table-view/table-view.component";
import { CommonModule } from '@angular/common';
import { OralTestGraphComponent } from "../stats-charts/oral-test-graph.component";
import { ProgressTestGraphComponent } from "../stats-charts/progress-test-graph.component";
import { LiveTestGraphComponent } from "../stats-charts/live-test-graph.component";
import { FlashcardGraphComponent } from "../stats-charts/flashcard-graph.component";
import { AiTestGraphComponent } from "../stats-charts/ai-test-graph.component";

@Component({
  selector: 'app-flashcard-report',
  standalone: true,
  imports: [PieChartComponent, TableViewComponent, CommonModule, OralTestGraphComponent, ProgressTestGraphComponent, LiveTestGraphComponent, FlashcardGraphComponent, AiTestGraphComponent],
  templateUrl: './flashcard-report.component.html',
  styleUrl: './flashcard-report.component.css'
})
export class FlashcardReportComponent {

  currentTab = 'flashcard';
tabs = [
  { name: 'flashcard', value: 'flashcard' },
  { name: 'AI Test', value: 'ai-test' },
  { name: 'Oral Test', value: 'oral-test' },
  { name: 'Progress Test', value: 'progress-test' },
  { name: 'Live Test', value: 'live-test' },
];

tableData = {
  label:['date','time','course','video_title','status'],
  data:[
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"],
    ["19 Dec, 2024", "06:12pm", "English Vocab - 500", "Port", "80%"]
  ]
}

certifacates=[
  {
    "title": "Certified Web Developer",
    "img": "https://marketplace.canva.com/EAF7h2vFXaU/2/0/1600w/canva-blue-and-gold-elegant-curved-certificate-of-achievement-certificate-HTxQpZIhLas.jpg",
    "issued_by": "Tech Academy",
    "date_issued": "2024-01-15",
    "validity": "Lifetime"
  },
  {
    "title": "Advanced UX/UI Designer",
    "img": "https://marketplace.canva.com/EAFlVDzb7sA/3/0/1600w/canva-white-gold-elegant-modern-certificate-of-participation-Qn4Rei141MM.jpg",
    "issued_by": "Design Institute",
    "date_issued": "2023-12-10",
    "validity": "5 years"
  },
  {
    "title": "Data Science Professional",
    "img": "https://d2vyhi5ouo1we3.cloudfront.net/force_jpg/aHR0cHM6Ly9pbWFnZXMuYmFubmVyYmVhci5jb20vcmVxdWVzdHMvaW1hZ2VzLzAwOC85MjQvNTc5L29yaWdpbmFsL2VhYzQyY2FiZjM5YzIxY2Y4NThlNWY4NDRlZmM0YTA1MjJmOGUxNzkucG5nPzE2MzI4MDgzMDI=/image.jpg",
    "issued_by": "AI Learning Hub",
    "date_issued": "2024-02-20",
    "validity": "3 years"
  },
  {
    "title": "Flutter App Developer",
    "img": "https://marketplace.canva.com/EAFy42rCTA0/1/0/1600w/canva-blue-minimalist-certificate-of-achievement-_asVJz8YgJE.jpg",
    "issued_by": "Mobile Dev Academy",
    "date_issued": "2024-03-05",
    "validity": "Lifetime"
  },
  {
    "title": "Cybersecurity Specialist",
    "img": "https://sertifier.com/blog/wp-content/uploads/2020/10/certificate-text-samples.jpg",
    "issued_by": "Security Training Center",
    "date_issued": "2023-11-25",
    "validity": "5 years"
  }
]

}
